export default "__VITE_ASSET__4OI4Qvxg__"